module.exports = __webpack_public_path__ + "img/destombamento.eddb8168.png";